export function Table({ children, className = "" }) {
  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="w-full text-sm">{children}</table>
    </div>
  );
}

export function THead({ children }) {
  return (
    <thead className="text-xs uppercase tracking-wide text-brand-slate border-b border-gray-100 dark:border-[var(--border-soft)]">
      {children}
    </thead>
  );
}

export function TR({ children, onClick, className = "" }) {
  return (
    <tr
      onClick={onClick}
      className={`${onClick ? "cursor-pointer hover:bg-gray-50 dark:hover:bg-[var(--bg-soft)]" : ""} border-b border-gray-50 dark:border-[var(--border-soft)] last:border-b-0 ${className}`}
    >
      {children}
    </tr>
  );
}

export function TH({ children, className = "", onClick }) {
  return (
    <th
      onClick={onClick}
      className={`px-3 py-2 text-left font-medium ${onClick ? "cursor-pointer hover:text-brand-ink" : ""} ${className}`}
    >
      {children}
    </th>
  );
}

export function TD({ children, className = "", onClick, title, colSpan }) {
  return (
    <td
      onClick={onClick}
      title={title}
      colSpan={colSpan}
      className={`px-3 py-2.5 text-brand-ink dark:text-[var(--text-primary)] ${className}`}
    >
      {children}
    </td>
  );
}

export function EmptyState({ icon: Icon, title, message, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      {Icon && <Icon size={32} className="text-brand-slate mb-3" />}
      <div className="font-medium text-brand-ink dark:text-[var(--text-primary)]">{title}</div>
      {message && <div className="text-sm text-brand-slate mt-1 max-w-sm">{message}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}